import { useTranslation } from 'react-i18next';

import type { PeriodFilter } from '@/hooks';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { PERIOD_PRESETS } from '@/helpers';

import { PRESET_LABEL_KEYS } from './consts';
import { PeriodPicker } from './PeriodPicker';

type Props = {
  filter: PeriodFilter;
};

export const PeriodToolbar = (props: Props) => {
  const { filter } = props;
  const { t } = useTranslation();

  const onPresetChange = (value: string) => {
    const preset = PERIOD_PRESETS.find((item) => item === value);
    if (preset) {
      filter.onPresetSelect(preset);
    }
  };

  return (
    <div className="flex flex-wrap items-end gap-3">
      <Tabs
        value={filter.activePreset}
        onValueChange={onPresetChange}
      >
        <TabsList variant="segmented">
          {PERIOD_PRESETS.map((preset) => (
            <TabsTrigger
              key={preset}
              value={preset}
            >
              {t(PRESET_LABEL_KEYS[preset])}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="flex flex-wrap items-end gap-3 *:w-52">
        <PeriodPicker filter={filter} />
      </div>
    </div>
  );
};
